import { Controller } from "@hotwired/stimulus"

// Disables submit until required fields and at least one selected prestacion are present.
export default class extends Controller {
  static targets = ["submit", "solicitanteHidden"]

  static values = {
    fromTurnero: Boolean
  }

  connect() {
    this.validate = this.validate.bind(this)

    this.element.addEventListener("input", this.validate)
    this.element.addEventListener("change", this.validate)

    this.observer = new MutationObserver(() => this.validate())
    this.observer.observe(this.element, { childList: true, subtree: true })

    this.validate()
  }

  disconnect() {
    this.element.removeEventListener("input", this.validate)
    this.element.removeEventListener("change", this.validate)

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  validate() {
    if (!this.hasSubmitTarget) return

    const formValid = this.element.checkValidity()
    const hasPrestaciones = this.selectedPrestacionesCount() > 0
    const solicitanteOk = !this.fromTurneroValue || (this.hasSolicitanteHiddenTarget && this.solicitanteHiddenTarget.value.trim() !== "")

    this.submitTarget.disabled = !(formValid && hasPrestaciones && solicitanteOk)
  }

  selectedPrestacionesCount() {
    const wrappers = Array.from(this.element.querySelectorAll(".imagen-prestaciones-form-wrapper"))

    return wrappers.filter((wrapper) => {
      if (wrapper.hidden || wrapper.classList.contains("d-none")) return false

      const destroyInput = wrapper.querySelector('input[name*="[_destroy]"]')
      if (destroyInput && destroyInput.value === "1") return false

      const codeStudy = wrapper.querySelector('input[name*="[code_study]"]')?.value?.trim() || ""
      const study = wrapper.querySelector('input[name*="[study]"]')?.value?.trim() || ""

      return codeStudy !== "" || study !== ""
    }).length
  }
}
